export default {
  name: 'KnFormClub',
  components: {},
  mixins: [],
  props: {},
  data() {
    return {};
  },
  computed: {},
  created() {},
  methods: {},
};
